import React from "react";
import { default as MUITableHead } from "@mui/material/TableHead";
import styled from "styled-components";

const StyledMUITableHead = styled(MUITableHead)``;

export const TableHead = (props) => {
  return <StyledMUITableHead {...props} />;
};
